<template>
  <div v-if="error">
    There's been an error logging in. Please click back, check your information and try
    again.
  </div>
  <div v-else>
    <Loading />
  </div>
</template>

<script setup lang="ts">
import { useRouter, useRoute } from "vue-router";
import { useUserStore } from "../store/userStore";
import { useAdminStore } from "../store/adminStore";
import { useAlertStore } from "../store/alertStore";
import { useBldgStore } from "../store/bldgStore";
import { usePersonStore } from "../store/personStore";
import { useRespondStore } from "../store/respondStore";
import { useTrainingStore } from "../store/trainingStore";
import { useReportStore } from "../store/reportStore";

const router = useRouter();
const route = useRoute();
const userStore = useUserStore();

const adminStore = useAdminStore();
const alertStore = useAlertStore();
const bldgStore = useBldgStore();
const personStore = usePersonStore();
const respondStore = useRespondStore();
const trainingStore = useTrainingStore();
const reportStore = useReportStore();

const error = ref(false);
var property = computed(() => bldgStore.property);

var isLoggedIn = computed(() => userStore.isLoggedIn);
var isUserLoading = computed(() => userStore.isUserLoading);
var isUserLoadedFromServer = computed(() => userStore.isUserLoadedFromServer);

watch(property, redirectAfterUserLoaded);
watch(isLoggedIn, redirectAfterUserLoaded);
watch(isUserLoading, redirectAfterUserLoaded);
watch(isUserLoadedFromServer, redirectAfterUserLoaded);

//Extract token from query, load user and redirect
onMounted(async () => {
  let urlToken = route.query.authtoken?.toString() || route.query?.token?.toString();
  let siteCode = route.params?.sitecode?.toString();

  if (urlToken && siteCode) {
    console.log("Token page found token");
    userStore.setAuthToken(urlToken);
    adminStore.setAuthToken(urlToken);
    alertStore.setAuthToken(urlToken);
    bldgStore.setAuthToken(urlToken);
    personStore.setAuthToken(urlToken);
    respondStore.setAuthToken(urlToken);
    trainingStore.setAuthToken(urlToken);
    reportStore.setAuthToken(urlToken);

    await redirectAfterUserLoaded();
  } else {
    error.value = true;
  }
});

async function redirectAfterUserLoaded() {
  // this page will keep showing loading animation until redirect or error.
  // This function gets called repeatedly as things load
  if (error.value) return;

  if (property.value) {
    let siteCode = route.params?.sitecode?.toString();
    let userLoadingNotStarted = !isUserLoadedFromServer.value && !isUserLoading.value;

    if (siteCode && userLoadingNotStarted) {
      await userStore.getUser(siteCode, property.value.portalId!);
    }

    let userLoadingComplete = isUserLoadedFromServer.value && !isUserLoading.value;

    if (userLoadingComplete) {
      if (isLoggedIn.value) {
        let returnUrl = route.query.returnUrl?.toString() || route.hash?.substring(1);

        var redirect = "/" + siteCode;
        if (returnUrl) {
          if (returnUrl.startsWith(redirect)) {
            redirect = returnUrl;
          } else {
            if (!returnUrl.startsWith("/")) redirect += "/";
            redirect += returnUrl;
          }
        }

        console.log("Token Loaded. redirect to " + redirect);
        router.replace(redirect);
      } else {
        error.value = true;
      }
    }
  }
}
</script>
